import { SUB_SIDEBAR_KEYS } from 'consts/sidebar'

import MediaContent from 'containers/SubSidebar/MediaContent'
import { AudioContent } from 'containers/SubSidebar/AudioContent'
import AiImageContent from 'containers/SubSidebar/AiImageContent'
import AIVideoContent from 'containers/SubSidebar/AIVideoContent'
import TtsContent from 'containers/SubSidebar/TtsContent'
import TextContent from 'containers/SubSidebar/TextContent'
import MusicVersioning from 'containers/SubSidebar/AudioContent/components/music-versioning'
import AIImageOverlayContent from './AiImageContent/AIImageOverlayContent'
import AIVideoOverlayContent from './AIVideoContent/AIVideoOverlayContent'

import { OverlayItemType, TOverlayContent, TOverlayItemType } from 'types'
import { PROJECT_MEDIA_TYPES } from 'consts'
import ImageOverlayContent from './MediaContent/ImageOverlayContent'
import TextOverlayContent from './TextContent/TextOverlayContent'
import AiLibContent from './AiLibContent'

export const OVERLAY_CONTENT: TOverlayContent = {
  aiImage: <AIImageOverlayContent />,
  aiVideo: <AIVideoOverlayContent />,
  musicVersioning: <MusicVersioning />,
  image: <ImageOverlayContent />,
  text: <TextOverlayContent />
}

export const SUB_SIDEBAR_CONTENT: Record<string, React.ReactNode> = {
  [SUB_SIDEBAR_KEYS.UPLOAD]: <MediaContent />,
  [SUB_SIDEBAR_KEYS.AUDIO]: <AudioContent />,
  [SUB_SIDEBAR_KEYS.AI_IMAGE]: <AiImageContent />,
  [SUB_SIDEBAR_KEYS.AI_VIDEO]: <AIVideoContent />,
  [SUB_SIDEBAR_KEYS.TTS]: <TtsContent />,
  [SUB_SIDEBAR_KEYS.TEXT]: <TextContent />,
  [SUB_SIDEBAR_KEYS.IMAGE]: <ImageOverlayContent />,
  [SUB_SIDEBAR_KEYS.AI_LIB]: <AiLibContent />
}

export const VISUAL_MEDIA_TYPE_OVERLAY: Record<string, TOverlayItemType> = {
  [PROJECT_MEDIA_TYPES.aiImage]: OverlayItemType.AI_IMAGE,
  [PROJECT_MEDIA_TYPES.image]: OverlayItemType.IMAGE,
  [PROJECT_MEDIA_TYPES.text]: OverlayItemType.TEXT
}
